module.exports = __webpack_public_path__ + "static/media/9.746dc575.jpg";